/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/
(function(){
	'use strict';
    
    // Biography window controls - rewritten in vanilla js
    window.addEventListener('load', function() {    
        const viewBioLinks = document.querySelectorAll('.bio-toggle');
        const overlay = document.getElementById('overlay');
        viewBioLinks.forEach(function(link) {
            link.addEventListener('click', function() {                
                link.classList.toggle('open');
                const bioDiv = link.parentElement.querySelector('.member-bio');
                bioDiv.classList.toggle('open');
                overlay.classList.toggle('active');
            });
        });
        
        const closeBioBtns = document.querySelectorAll('.close-bio');
        closeBioBtns.forEach(function(btn) {
            btn.addEventListener('click', function() {                
                const bioDiv = btn.closest('.member-bio');
                bioDiv.classList.toggle('open');
                overlay.classList.toggle('active');
            });
        });
    });

	// Load event function ... most custom stuff goes here. Safer for async.
	jQuery( window ).on( 'load', function() {
		var search_form = jQuery( '#search-form' );
		var search_input = jQuery( '#search-input' );
		search_form.click( function( e ) {
			if( jQuery( event.target ).hasClass( 'search-form__button' ) && search_input.val() == "" ) {
				search_input.focus();
				search.toggleClass( 'search-form--active' );
				event.preventDefault();
			} else {
				search_input.focus();
				search_form.addClass( 'search-form--active' );
			}
		});

		// adds class to nav menu to adjust break points to fit extra menu items
		jQuery('.search-form svg').on('click', function(event){
				// width determines the width of the search field when expanded
				var windowSize = jQuery(window).width();
				if ( windowSize >= 992) {
					console.log("hello");
					event.preventDefault();
					jQuery('.search-form').css('width', '10rem');
					jQuery('.search-form__field').addClass('search-form__focus');
				}
			});

		search_input.focusout( function( event ) {
			if( search_input.val() == "") {
				searchForm.removeClass( 'search-form--active' );
			}
		});
		// Along with the js at the top of cms-partner-slider.php, this hides the cloned partners from the slider on the homepage from screen readers
		jQuery('.layout-partner-slider .partial-partner-slider__icon').each(function(e) {
			if (jQuery(this).hasClass('duplicate')) {
				jQuery(this).attr("aria-hidden","true")
			}
		});

		// search child dom elements for a[href], and follow the fist one on click events 2015-11-03
		jQuery( ".linkclicker" ).click( function(e) {
			var _this = jQuery( this );
			if ( _this.find( "a" ) ) {
				e.preventDefault();
				if ( _this.find( "a:first" ).attr( "target" ) ) {
					// new tab
					window.open( _this.find( "a:first" ).attr( "href" ) );
				} else {
					// same tab
					window.location = _this.find( "a:first" ).attr( "href" );
				}
			}
		});

		// 2016-05-15, force opening external links, and pdf's, in new tab.
		if ( ! jQuery( 'a' ).attr( 'target' ) ) {
			jQuery( 'a[href^=http]:not([href*="' + dbs.http_host + '"])' ).attr( 'target', '_blank' ).attr( 'rel', 'noopener' );
		}

		// 2017-09-12, add a X "clear form field" option to these fields:
		jQuery( "input[type=text],input[type=email],textarea" ).addClear( { color: "#999" } );

		/**
		 * 	The following removes gratuitous p tags inserted by the editor around img tags. 2018-03-28
	 	 */
		jQuery( ".layout p" ).each( function() { 	         		// For each paragraph of .layout class
			if ( (jQuery(this).find( "img" ).length ) &&     		// If there's an image
					( !jQuery.trim(jQuery(this).text()).length ) ) {// and there's no text, then ... get mean.
				jQuery(this).closest( "p" ).find( "*" ).first().addClass( "unwrapped" ).unwrap();  // if the ancestor is a p tag, do what you have to do
			}
		});

		// Attempts to remove orphans by inserting non breaking space,
		jQuery("p,h1,h2,h3,h4,h5,h6").each(function(i,e) {
			var text = jQuery(e).html();
			text = text.split(' ');
			// Only apply to longer titles to make sure it looks correct more often.
			if (text.length > 3){
				var lastWord = text.pop();
				var nextToLastWord = text.pop();
				// text = text.join(' ') + "&nbsp;" + lastWord;
				if( (nextToLastWord + lastWord).length < 20 ){
					text = text.join(' ') + ' ' + nextToLastWord + '&nbsp;' + lastWord;
				}else{
					text = text.join(' ') + ' ' + nextToLastWord + ' ' + lastWord;
					// Ignore - Last words add up too long.
				}

				jQuery(e).html(text);
			}
		});

		// Close biography modal on click outside of it
		$('body').on('click', function(evt) {
			if ( $(evt.target).hasClass('bio-toggle') || $(evt.target).hasClass('close-bio') ) {
				return;
			}		
			// For descendants of modals
			if ( $(evt.target).closest('.member-bio').length ) {
				return;
			}

			$('.member-bio.open').removeClass('open');
			$('#overlay').removeClass('active');
		});
	});
})();
